import { memo, useEffect, useState } from "react";
import { RoomAndTypeSelect } from "../../common/RoomAndTypeSelect";
import { Button } from "antd";
import { mdlIdCodeNamePair } from "../../../models/domain/IdCodeNamePair";
import { RoomTableForNewAdd } from "../../definitions/hotel/RoomTableForNewAdd";
import { useTranslation } from "react-i18next";
import { mdlHotelRoomAndType } from "../../../models/domain/HotelRoomAndType";

export type AddRoomAndTypeProps = {
    activeItem?: mdlHotelRoomAndType;
    onTableItemSelect?: any;
    roomTypeList?:mdlIdCodeNamePair[] ;
    roomList?:mdlIdCodeNamePair[] ;
    selectedRoomListForAddNew?:string[] ;
    selectedRoomTypeListForAddNew?:string[] ;
    defaultValue?:string;
    selectedHotel?:string;
    onSelected?:Function;
    fnAddNew?: Function;
    fnModalClose?: Function;
    fnSelectAll?: Function;
    fnActiveItemSelect?: Function;
    roomCapacityList?:mdlHotelRoomAndType[];
    fnPrepareRoomCapacityList?: Function;
    autoFocus?:string;
    fnSetAutoFocus?: Function;
}

export const AddRoomAndType = memo(function AddRoomAndType(props: AddRoomAndTypeProps) {
    const { t } = useTranslation();
    const [selectedData, setSelectedData] = useState<string | string[]>();
    const addNew = () => {
        props.fnAddNew && props.fnAddNew(props.activeItem?.id);
    }
    useEffect(() => {
        if(props.activeItem?.hotelRoomTypeId && !selectedData){
           setSelectedData([props.activeItem?.hotelRoomTypeId])
        }
    }, [props]);

    const closeModal = () => {
        props.fnModalClose && props.fnModalClose();
    }
    const onSelected = (value:string |string[]) => {
        setSelectedData(value);
        props.onSelected && props.onSelected(value);
    }
    return (
        <>
        <div className="row">
            <div className="col-sm-3 mt-4 pt-1 text-end">
                <label className=" text-right"> {t("common.choose")} : </label>
            </div>
            <div className="col-sm-9 mt-4">
                <div className="me-2">
                    <RoomAndTypeSelect 
                    mode="multiple"
                    roomTypeList={props.roomTypeList} 
                    onChange={onSelected} 
                    defaultValue={props.activeItem?.hotelRoomTypeId} 
                    selectedHotel={props.selectedHotel}/>
                </div>
            </div>
            <div className="col-sm-12 mt-4">
                <div className="me-2">
                    <RoomTableForNewAdd 
                        fnActiveItemSelect={props.fnActiveItemSelect}
                        activeItem={props.activeItem}
                        fnSelectAll={props.fnSelectAll} 
                        selectedRoomListForAddNew={props.selectedRoomListForAddNew} 
                        selectedRoomTypeListForAddNew={props.selectedRoomTypeListForAddNew} 
                        onTableItemSelect={props.onTableItemSelect} 
                        selectedHotel={props.selectedHotel} 
                        pagination={{ pageSize: props.roomList?.length }} 
                        tableItems={props.roomList}
                        roomCapacityList={props.roomCapacityList}
                        fnPrepareRoomCapacityList ={props.fnPrepareRoomCapacityList}
                        autoFocus={props.autoFocus}
                        fnSetAutoFocus ={props.fnSetAutoFocus}
                     />
                </div>
            </div>
            <div className="col-md-12 mt-4 text-end ">
                <Button className="btn btn-secondary btn-dim me-2 " onClick={addNew} disabled={!selectedData}>{props.activeItem ? t("common.update") : t("common.addNew")}</Button>
                <Button className="btn btn-danger btn-dim me-2 " onClick={closeModal}>{t("common.close")}</Button>
            </div>
        </div>
        </>
    )
})